export class MapLocation {
  latitude: number;
  longitude: number;
  address?: string;
}
